import View from './view.js'
import { useDataValue } from 'Simple/Data.js'
import React from 'react'

export default function Logic(props) {
  let lead = useDataValue({
    context: 'lead',
    viewPath: props.viewPath,
  })

  return (
    <View
      {...props}
      isDisabled={
        props.disabled ||
        !lead.location?.id ||
        !lead.metadata.person.phoneDetails?.number ||
        !lead.metadata.person.email
      }
    />
  )
}
